export default __webpack_public_path__ + "static/media/customerPreviewIcon.075685d7.svg";